import React from 'react';
export function BibleVerseHero() {
  return <section className="w-full bg-[#f5f1ed] py-6 md:py-8" data-id="element-3">
      <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center" data-id="element-4">
        {/* Compact Bible Verse */}
        <p className="font-serif text-sm md:text-base text-[#2d4a3a] italic mb-2" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-5">
          "And the dove came back to him in the evening, and behold, in her
          mouth was a freshly plucked olive leaf."
        </p>

        {/* Scripture Reference */}
        <p className="text-[#496f58] font-medium text-xs tracking-wide" data-id="element-6">
          — Genesis 8:11 —
        </p>
      </div>
    </section>;
}